import {
  addErrorHandler,
  getAppStatus,
  LifeCycles,
  LOAD_ERROR,
  registerApplication,
  start,
} from "single-spa";
import { props } from "./config/props";
import { ProductPathEnum } from "./enum/product-path.enum";

declare global {
  interface Window {
    __nps_modal_defined?: boolean;
  }
}

export function registerExternalWebComponents() {
  if (!window.hasOwnProperty("__nps_modal_defined")) {
    try {
      require("@grao-direto/gd-nps");
      window.__nps_modal_defined = true;
      console.log("[root-config] nps-modal registrado com sucesso.");
    } catch (err) {
      console.error("[root-config] erro ao registrar nps-modal:", err);
    }
  } else {
    console.log("[root-config] nps-modal já registrado, ignorando...");
  }
}
registerExternalWebComponents();

registerApplication({
  name: "@gclient",
  app: () => System.import<LifeCycles>("@gd/gclient"),
  activeWhen: ["/clientes"],
  customProps: props,
});

registerApplication({
  name: "@common",
  app: () => System.import<LifeCycles>("@gd/common"),
  activeWhen: (location: Location) =>
    !location.pathname.includes("/barter") &&
    !location.pathname.includes("/clientes") &&
    !location.pathname.includes("/backoffice"),
  customProps: getCustomProps(),
});

registerApplication({
  name: "@header",
  app: () =>
    System.import<any>("@gd/header").then((res) => ({
      bootstrap: res.headerBootstrap,
      mount: res.headerMount,
      unmount: res.headerUnmount,
    })),
  activeWhen: ["/"],
  customProps: getCustomProps(),
});

registerApplication({
  name: "@sidenav",
  app: () =>
    System.import<any>("@gd/header").then((res) => {
      return {
        bootstrap: res.sidenavBootstrap,
        mount: res.sidenavMount,
        unmount: res.sidenavUnmount,
      };
    }),
  activeWhen: ["/"],
  customProps: getCustomProps(),
});

registerApplication({
  name: "@barter",
  app: () => System.import<LifeCycles>("@gd/barter"),
  activeWhen: (location) => location.pathname.startsWith("/barter"),
  customProps: props,
});

registerApplication({
  name: "@backoffice",
  app: () => System.import<LifeCycles>("@gd/backoffice"),
  activeWhen: (location) => location.pathname.startsWith("/backoffice"),
  customProps: getCustomProps(),
});

addErrorHandler((err) => {
  if (getAppStatus(err.appOrParcelName) === LOAD_ERROR) {
    System.delete(System.resolve(err.appOrParcelName));
  }
});

start({
  urlRerouteOnly: true,
});

function getCustomProps() {
  const baseProps = props();

  const otherSolutions = baseProps.otherSolutions;

  if (!otherSolutions) return baseProps;

  const solutionPath = window.location.pathname.split("/")[1] ?? "";

  if (solutionPath && otherSolutions[solutionPath]) {
    window.localStorage.setItem("currentApplication", solutionPath);
    return {
      ...baseProps,
      apiUrl: otherSolutions[solutionPath].url,
      appTitle: otherSolutions[solutionPath].title,
    };
  }

  const currentApplication = window.localStorage.getItem("currentApplication");

  const shouldClearStorage =
    currentApplication !== solutionPath &&
    Object.values(ProductPathEnum).includes(solutionPath as ProductPathEnum);

  if (shouldClearStorage) {
    window.localStorage.removeItem("currentApplication");
  }

  if (currentApplication && otherSolutions[currentApplication]) {
    return {
      ...baseProps,
      apiUrl: otherSolutions[currentApplication].url,
      appTitle: otherSolutions[currentApplication].title,
    };
  }

  return baseProps;
}
